<!--

企业实体信息的编辑表单组件，供“新增”和“修改”的组件调用

-->
<template>
  <div>
    <h3>
      <el-page-header @back="$router.push('enterprise')" content="编辑" />
    </h3>
    <el-card>
      <div style="text-align: right; margin-bottom: 12px">
        <!-- 否则显示启动编辑按钮 -->
        <el-button
          icon="el-icon-edit"
          type="warning"
          round
          size="large"
          style="padding: 4px 12px"
          @click="save"
        >
          保存
        </el-button>
      </div>
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        size="mini"
        label-position="top"
      >
        <el-row :gutter="20">
          <!-- 左栏 -->
          <el-col :span="16">
            <!-- 第一行 -->
            <el-row :gutter="10">
              <el-col :span="10">
                <el-form-item label="企业全称" prop="name">
                  <el-input
                    v-model="form.name"
                    placeholder="工商注册登记的全名"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="企业简称" prop="nameAbbr">
                  <el-input
                    v-model="form.nameAbbr"
                    placeholder="简称或俗称，最多8个字"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="信用代码" prop="credit">
                  <el-input
                    v-model="form.credit"
                    placeholder="统一社会信用代码"
                    maxlength="50"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="成立年份" prop="foundYear">
                  <el-input-number
                    v-model="form.foundYear"
                    controls-position="right"
                    :min="1990"
                    :max="new Date().getFullYear()"
                    placeholder="成立年份"
                  />
                </el-form-item>
              </el-col>
              <!-- 第二行 -->
              <el-col :span="10">
                <el-form-item label="所在乡镇" prop="town">
                  <el-select
                    v-model="form.town"
                    clearable
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="t in towns"
                      :key="t.value"
                      :label="t.label"
                      :value="t.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="详细地址" prop="address">
                  <el-input v-model="form.address" :rows="2" maxlength="100" />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="联系电话" prop="phone">
                  <el-input
                    type="text"
                    oninput="value=value.replace(/\D/g,'')"
                    placeholder="请输入数字"
                    v-model="form.phone"
                    maxlength="11"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <!-- 第三行 -->
              <el-col>
                <el-form-item label="企业简介" prop="memo">
                  <el-input v-model="form.memo" type="textarea" :rows="4" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>

          <!-- 右栏 -->
          <el-col :span="8">
            <el-form-item label="工商执照">
              <el-upload
                :action="`${uploadBaseUrl}/upload/enterprise/${form.id}/facade`"
                :show-file-list="false"
                :on-success="handleLicenseSuccess"
                :before-upload="beforeLicenseUpload"
              >
                <!--            <img  v-if="licenseImgUrl" :src="licenseImgUrl" class="avatar" />-->
                <!-- <img  v-if="licenseImgUrl" :src="licenseImgUrl" class="avatar" /> -->
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div style="height: 250px; border: dashed 1px #cfcfcf">
                工商执照
                <!-- <img :src="`${imgBaseUrl}/enterprise/facade/${this.id}.jpg`" class="avatar" /> -->
                <img :src="licenseImgUrl" class="avatar" />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="形象展示和资质荣誉">
          <!-- <el-row :gutter="20">
        <el-col :span="4">
          <div class="photo"></div>
        </el-col>
      </el-row> -->
          <el-upload
            :action="`${uploadBaseUrl}/upload/enterprise/${form.id}/honor`"
            list-type="picture-card"
            :on-preview="handleHonorPreview"
            :on-change="handleChange"
            :on-remove="handleRemove"
            :on-success="handleHonorSuccess"
            :file-list="fileList"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <!--      <div v-if="honorImgUrls && honorImgUrls.length > 0">-->
          <!--        <img-->
          <!--          v-for="(item, i) in honorImgUrls"-->
          <!--          :src="item"-->
          <!--          :key="i"-->
          <!--          class="avatar"-->
          <!--        />-->
          <!--      </div>-->
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
// 引入乡镇信息列表，供下拉列表使用，未来可能需要升级为后台接口
import towns from '@/common/towns.js'
import {
  enterpriseDetail,
  enterpriseUpdate,
  getHonorsByEnterpriseId,
  photoDelete,
} from '@/api/enterprise.js'
export default {
  name: 'Editor',
  props: {
    /**
     * 初始数据，非必选项，若不输入，则表示正在新建一条企业信息，若输入了，则表示在修改
     */
    enterprise: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      form: {
        id: '',
        name: '',
        nameAbbr: '',
        credit: '',
        foundYear: '',
        town: '',
        address: '',
        memo: '',
        phone: '',
      },
      rules: {
        name: [
          { required: true, message: '必须输入企业全名', trigger: 'blur' },
          {
            min: 3,
            max: 20,
            message: '企业全名长度限制3~20个字',
            trigger: 'blur',
          },
        ],
        nameAbbr: [
          { required: true, message: '必须输入企业简称', trigger: 'blur' },
          {
            min: 2,
            max: 8,
            message: '企业简称长度限制2~8个字',
            trigger: 'blur',
          },
        ],
        town: [
          { required: true, message: '必须选择所在乡镇', trigger: 'blur' },
        ],
      },
      towns: towns,
      /**
       * 工商执照图片地址
       */
      licenseImgUrl: '',
      honorImgUrls: [],
      fileList: [],
    }
  },
  watch: {},
  computed: {
    userId() {
      return this.$store.getters.userId
    },
    id() {
      return this.$store.getters.currentEnterprise.id
    },
    uploadBaseUrl() {
      return process.env.APP_BASE_URL
    },
    imgBaseUrl() {
      return process.env.IMG_BASE_URL
    },
  },
  mounted() {
  
    this.enterpriseDetailGet()
    this.enterprisePhoto()
  },
  methods: {
    enterprisePhoto() {
   
      getHonorsByEnterpriseId(this.id).then((resp) => {
        const { imgBaseUrl, honorImgUrls } = this
      
        const urls = resp.data
        console.log('urls', urls)
        urls.forEach((u) => {
          honorImgUrls.push(`${imgBaseUrl}/${u.addr}`)
          let option = {}
          option.id = u.id
          option.url = `${imgBaseUrl}/${u.addr}`
          this.fileList.push(option)
        })
       
      })
    },
    save() {
      enterpriseUpdate(this.form).then((data) => {
        this.$message.success(data.message)
        this.$router.push('enterprise')
      })
    },
    enterpriseDetailGet() {
      enterpriseDetail(this.$store.getters.currentEnterprise.id).then(
        (data) => {
          Object.keys(data.data).forEach((item) => {
            this.form[item] = data.data[item]
          })
        }
      )
      this.licenseImgUrl = `${this.imgBaseUrl}/enterprise/facade/${
        this.id
      }.jpg?v=${new Date().getTime()}`

    },
    /**
     * 供父组件调用的方法，当父组件要提交数据，通过该方法获取表单内填写的数据，然后由父组件提交到服务器
     */
    getFormData() {
      // TODO 需要先触发表单验证，验证通过则返回form数据，否则返回null
      return this.form
    },
    getInfo() {
      return this.form
    },
    formSubmit(f, that) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.userId = this.userId
          enterpriseAdd(this.form).then((resp) => {
            f(that)
            const ent = resp.data
          })
        }
      })
    },
    /**
     * 重置表单的方法，通常由父组件调用
     */
    reset() {
      // this.form = JSON.parse(JSON.stringify(this.enterprise))
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.resetFields()
      })
    },
    /**
     * 上传工商执照成功的处理
     */
    handleLicenseSuccess(res, file) {
      this.licenseImgUrl = URL.createObjectURL(file.raw)
    },
    /**
     * 上传工商执照之前的检查
     */
    beforeLicenseUpload(file) {
      console.log(file.size)
      const isJPG = file.type === 'image/jpeg'
      if (!isJPG) {
        this.$message.error('上传图片只支持 JPG 格式')
        return false
      }
      // else if (file.size / 1024 / 1024 > 1) {
      //   this.$message.error('上传图片大小不可超过 1MB')
      //   return false
      // }
    },
    handleRemove(file, fileList) {
      //  console.log("filename",this.id,file.url)
      // console.log("file",fileList)

      photoDelete(this.id, file.url).then(() => {
        console.log('删除成功')
      })

      // console.log("filename",file)
    },
    handleHonorPreview(file) {
      console.log(file)
    },
    handleChange(file) {},
    handleHonorSuccess(res, file) {
      console.log('handleHonorSuccess::', res.data)
    },
  },
}
</script>
<style scoped>
.photo {
  border: dashed 1px #cfcfcf;
  height: 120px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #cfcfcf;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 43px;
  color: #8c939d;
  width: 372px;
  height: 178px;
  line-height: 212px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/meta/enterprise/Editor.vue